// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletBanner_wallet-banner__kawGQ {
  padding-inline-start: 12rem;
  padding-block: 2.6rem;
  border-radius: 1.1rem;
  background: var(--wallet-banner);
  position: relative;
  margin-bottom: 7rem;
}

.WalletBanner_wallet-banner__balance-wrapper__tqvap {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.WalletBanner_wallet-banner__balance-title__O5HRB {
  color: #fff;
  font-size: var(--text-lg);
  font-weight: 500;
}

.WalletBanner_wallet-banner__balance__qpAaX {
  color: #fff;
  font-size: var(--text-4xl);
  font-weight: 700;
}

.WalletBanner_wallet-banner__coins__bjYeu {
  position: absolute;
  top: -3rem;
  right: 0;
}

.WalletBanner_wallet-banner__vector__BSDhx {
  position: absolute;
  left: 7.5rem;
  top: -3rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .WalletBanner_wallet-banner__kawGQ {
    padding-inline-start: 8rem;
    padding-block: 2.6rem;
  }

  .WalletBanner_wallet-banner__coins__bjYeu {
    width: 7rem;
    height: 7rem;
  }

  .WalletBanner_wallet-banner__vector__BSDhx {
    position: absolute;
    left: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Wallet/WalletBanner/WalletBanner.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF","sourcesContent":[".wallet-banner {\n  padding-inline-start: 12rem;\n  padding-block: 2.6rem;\n  border-radius: 1.1rem;\n  background: var(--wallet-banner);\n  position: relative;\n  margin-bottom: 7rem;\n}\n\n.wallet-banner__balance-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n}\n\n.wallet-banner__balance-title {\n  color: #fff;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.wallet-banner__balance {\n  color: #fff;\n  font-size: var(--text-4xl);\n  font-weight: 700;\n}\n\n.wallet-banner__coins {\n  position: absolute;\n  top: -3rem;\n  right: 0;\n}\n\n.wallet-banner__vector {\n  position: absolute;\n  left: 7.5rem;\n  top: -3rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .wallet-banner {\n    padding-inline-start: 8rem;\n    padding-block: 2.6rem;\n  }\n\n  .wallet-banner__coins {\n    width: 7rem;\n    height: 7rem;\n  }\n\n  .wallet-banner__vector {\n    position: absolute;\n    left: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wallet-banner": `WalletBanner_wallet-banner__kawGQ`,
	"wallet-banner__balance-wrapper": `WalletBanner_wallet-banner__balance-wrapper__tqvap`,
	"wallet-banner__balance-title": `WalletBanner_wallet-banner__balance-title__O5HRB`,
	"wallet-banner__balance": `WalletBanner_wallet-banner__balance__qpAaX`,
	"wallet-banner__coins": `WalletBanner_wallet-banner__coins__bjYeu`,
	"wallet-banner__vector": `WalletBanner_wallet-banner__vector__BSDhx`
};
export default ___CSS_LOADER_EXPORT___;
